import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';
import { activeToolSelector } from '~/store/mapSettings/toolsState/activeTool/mapSettingsToolsStateActiveTool.selectors';
import { MapSettingsToolsStateActiveTool } from '~/store/mapSettings/toolsState/activeTool/mapSettingsToolsStateActiveTool.state';

// Driven by the explicit active tool, not by which tool panel is currently open
export const isDataLayerToolActiveSelector = (state: AppState) =>
  activeToolSelector(state) === MapSettingsToolsStateActiveTool.DataLayers;

export const useIsDataLayerToolActiveSelector = () => useSelector(isDataLayerToolActiveSelector);

export const isBoundaryToolActiveSelector = (state: AppState) =>
  activeToolSelector(state) === MapSettingsToolsStateActiveTool.Boundary;
export const useIsBoundaryToolActiveSelector = () => useSelector(isBoundaryToolActiveSelector);

export const isDataLayerToolUpdatingSelector = (state: AppState) => state.frontendState.mapTools.dataLayers.isUpdating;
export const useIsDataLayerToolUpdatingSelector = () => useSelector(isDataLayerToolUpdatingSelector);

const dataLayersTemplatesEtagSelector = (state: AppState) => state.frontendState.mapTools.dataLayers.dataLayerTemplatesEtag;
export const useDataLayersTemplatesEtagSelector = () => useSelector(dataLayersTemplatesEtagSelector);
